import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableSectionGeometry = Loadable({
  loader: () => import('./SectionGeometry'),
  loading: Loader
});
